import {useTranslation} from "react-i18next";
import {useContext, useEffect, useState} from "react";
import {GlobalContext} from "../../../../utils/context/GlobalContextProvider.jsx";
import useDownloadState from "../../../../api/utilities/useDownloadState.js";
import {UserApi} from "../../../../api/authority/generated/index";
import OnBoardingLayout from "../OnBoardingLayout.jsx";
import FormContainer from "../../../../components/form/FormContainer.jsx";
import LoadingComponent from "../../../../components/LoadingComponent.jsx";
import FormError from "../../../../components/form/FormError.jsx";
import FormControl from "../../../../components/form/FormControl.jsx";
import FormButton from "../../../../components/form/FormButton.jsx";
import {useNavigate} from "react-router-dom";
import Button from "../../../../components/Button.jsx";

export default function SetPasswordStep() {

    let {context, getAuthorityConfiguration, updateIdentityUser} = useContext(GlobalContext);
    let {t} = useTranslation();

    let navigate = useNavigate();

    let [newPassword, setNewPassword] = useState('');
    let [newPasswordAgain, setNewPasswordAgain] = useState('');

    let [updatePressed, setUpdatePressed] = useState(false);

    let [state, setDownloading, setResult, setError] = useDownloadState();

    useEffect(() => {
        if (context.currentIdentity?.user.newPasswordRequired === false) {
            navigate('/');
        }

        if (!updatePressed) {
            return;
        }

        setUpdatePressed(false);

        if (newPassword !== newPasswordAgain) {
            setError(t('auth.passwords-must-match'));
            return;
        }

        setDownloading(true);

        new UserApi(getAuthorityConfiguration())
            .updatePassword({
                userId: context.currentIdentity?.user.id,
                updatePasswordInput: {
                    newPassword: newPassword,
                }
            })
            .then((r) => {
                updateIdentityUser(r.user);
                navigate('/');
            })
            .catch(setError)
            .finally(() => setDownloading(false));
    }, [updatePressed, state]);

    return (
        <OnBoardingLayout>
            <FormContainer>
                <LoadingComponent loading={state.downloading || updatePressed}>
                    {state.error && <FormError error={state.error}/>}
                    <FormControl
                        type={'password'}
                        label={t('auth.new-password')}
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                    />
                    <FormControl
                        type={'password'}
                        label={t('auth.password-again')}
                        value={newPasswordAgain}
                        onChange={(e) => setNewPasswordAgain(e.target.value)}
                    />
                    <Button onClick={() => setUpdatePressed(true)}>
                        {t('onboarding.update-password')}
                    </Button>
                </LoadingComponent>
            </FormContainer>
        </OnBoardingLayout>
    );
}
